import React from 'react';
import { ChevronRight, LogOut } from 'lucide-react';

/* ── Desktop: Menu Cards Grid ── */
const ProfileMenuGrid = ({ menuItems, handleMenuClick, handleLogout, handleDeleteProfile }) => {
  return (
    <div className="profile-menu-grid">
      {menuItems.map((item) => (
        <div
          key={item.id}
          className="profile-menu-card"
          onClick={() => handleMenuClick(item.route)}
        >
          <div className="profile-menu-icon" style={{ backgroundColor: `${item.color}15` }}>
            <span style={{ color: item.color }}>
              {item.icon}
            </span>
          </div>
          <h5 className="profile-menu-title">{item.title}</h5>
          <p className="profile-menu-subtitle">{item.subtitle}</p>
          <ChevronRight className="profile-menu-arrow" />
        </div>
      ))}

      {/* Logout Card */}
      <div className="profile-menu-card profile-logout-card" onClick={handleLogout}>
        <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
          <span style={{ color: '#ef4444' }}>
            <LogOut size={22} />
          </span>
        </div>
        <h5 className="profile-menu-title">Log Out</h5>
        <p className="profile-menu-subtitle">Sign out of your account</p>
        <ChevronRight className="profile-menu-arrow" />
      </div>
      <div className="profile-menu-card profile-logout-card" onClick={handleDeleteProfile}>
        <div className="profile-menu-icon" style={{ backgroundColor: '#fee2e2' }}>
          <span style={{ color: '#ef4444' }}>
            <LogOut size={22} />
          </span>
        </div>

        <h5 className="profile-menu-title">Delete Account</h5>
        <p className="profile-menu-subtitle">Permanently remove your profile</p>

        <ChevronRight className="profile-menu-arrow" />
      </div>
    </div>
  );
};

export default ProfileMenuGrid;